import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(SectionWrapper)``

export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Description = styled(Typography)`
  max-width: 576px;
  color: #006b51;
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem(22)};
  font-style: normal;
  font-weight: 500;
  line-height: ${({ theme }) => theme.typography.pxToRem(32)};
  letter-spacing: -0.044px;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(60)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
    line-height: ${({ theme }) => theme.typography.pxToRem(28)};
  }
`

export const Image = styled(CustomImage)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-width: 150px;

  &.large {
    max-width: 300px;
  }
`

export const LogosContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  max-width: 615px;
  justify-content: center;
`

export const ImageContainer = styled.div``
